import { useId } from 'react';
import ValidatedSelect from '../forms/ValidatedSelect';

const HistoryTypeSelect = ({
    ariaLabel = 'Filter version history',
    label = 'History Type',
    name = 'versionHistorySection',
    options = [],
}) => {
    const id = useId();

    return (
        <div className="mb-4">
            <ValidatedSelect
                id={id}
                name={name}
                options={options}
                label={label}
                hideClear
                isSearchable={false}
                aria-label={ariaLabel}
            />
        </div>
    );
};

export default HistoryTypeSelect;
